let view = null;

export default {
	namespace: 'template-team',
	beforeEnter: async ({ current, next, trigger }) => {
		const { default: TeamView } = await import(/* webpackChunkName: "team-view" */ '../../templates/TeamView');
		view = new TeamView(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
